import type { FieldValues } from 'react-hook-form';
import { AutocompleteSelect } from '../../../design/AutoCompleteSelect';
import { VyFormField, type VyFormFieldProps } from '../VyFormField';

type VySelectFieldProps<TFieldValues extends FieldValues = FieldValues> = Omit<
  VyFormFieldProps<TFieldValues>,
  'children'
> &
  Omit<React.ComponentProps<typeof AutocompleteSelect>, 'name'> & {
    focused?: boolean;
  };

export const VySelectField = <TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  focused,
  textFieldProps = {},
  ...autocompleteProps
}: VySelectFieldProps<TFieldValues>) => {
  return (
    <VyFormField name={name} control={control}>
      {({ onChange: fieldOnChange, value: fieldValue, ...fieldProps }) => (
        <AutocompleteSelect
          {...fieldProps}
          {...autocompleteProps}
          textFieldProps={{
            ...textFieldProps,
            focused,
          }}
          onChange={(event, selectedOption, reason, details) => {
            const newValue = selectedOption?.id || selectedOption;
            fieldOnChange(newValue);
            autocompleteProps.onChange?.(event, selectedOption, reason, details);
          }}
          value={
            fieldValue
              ? (autocompleteProps.options?.find((option) => option.id === fieldValue) ?? null)
              : null
          }
        />
      )}
    </VyFormField>
  );
};
